//Dependencies............................................
import { FieldProps } from "@rjsf/utils";

//Components..............................................
import Conf20RulesField from "../../../../Components/VehicleConfigPageComp/Modals/CONF_2_0_Modal/CustomWidgets/Rules";
import Conf20CanMessageConfigField from "../../../../Components/VehicleConfigPageComp/Modals/CONF_2_0_Modal/CustomWidgets/CanMessageConfig"
import Conf20FunctionalityControlField from "../../../../Components/VehicleConfigPageComp/Modals/CONF_2_0_Modal/CustomWidgets/FunctionalityControl";
import Conf20CanBusConfigField from "../../../../Components/VehicleConfigPageComp/Modals/CONF_2_0_Modal/CustomWidgets/CanBusConfig";
import { displayToStored } from '../../../../utils/constants';

export default function CONF_2_0_Modal (props: FieldProps) {
    const { formData, onChange, errorSchema, fieldPathId } = props;
    // RJSF v6 requires the field's own path as onChange's 2nd argument.
    const rootOnChange = (updatedFormData: any) => onChange(updatedFormData, fieldPathId.path);

    const handleInvalidRules = (rules: any) => {
        const invalidRule = [
            {
                mask: [null],
                range_high: [null],
                range_low: [null]
            }
        ];
        if (JSON.stringify(rules) === JSON.stringify(invalidRule)) {
            return [];
        }

        return rules;
    };

    const handleCanBusConfigChange = (updatedCanBusConfig: any) => {
        const updatedCanMessageConfig = !updatedCanBusConfig.fd_enable
            ? Object.fromEntries(
                Object.entries(formData.can_message_config).map(([key]) => [
                    key,
                    {
                        ...formData.can_message_config[key],
                        dlc: formData.can_message_config[key]?.dlc <= 8 ? formData.can_message_config[key]?.dlc : displayToStored[8],
                        brs: false,
                    },
                ])
            )
            : formData.can_message_config;
        const updatedFormData = {
            ...formData,
            can_bus_config: updatedCanBusConfig,
            can_message_config: updatedCanMessageConfig,
        };
        rootOnChange(updatedFormData);
    };

    const handleCanMessageConfigChange = (updatedCanMessageConfig: any) => {
        const updatedFormData = {
            ...formData,
            can_message_config: updatedCanMessageConfig,
        };
        rootOnChange(updatedFormData);
    };

    const handleFunctionalityConfigChange = (updatedFunctionalityConfig: any) => {
        const updatedFormData = {
            ...formData,
            functionality_control: updatedFunctionalityConfig,
        };
        rootOnChange(updatedFormData);
    };

    const handleRulesChange = (updatedRules: any) => {
        const updatedFormData = {
            ...formData,
            rules: updatedRules,
        };
        rootOnChange(updatedFormData);
    };

    return (
        <div>
            <div style={{ marginBottom: '30px' }}>
                <Conf20CanBusConfigField
                    formData={formData.can_bus_config}
                    onChange={handleCanBusConfigChange}
                    errorSchema={errorSchema}
                />
            </div>
            <div style={{ marginBottom: '30px' }}>
                <Conf20CanMessageConfigField
                    formData={formData.can_message_config}
                    formContext={formData}
                    onChange={handleCanMessageConfigChange}
                    errorSchema={errorSchema}
                />
            </div>
            <div style={{ marginBottom: '30px' }}>
                <Conf20RulesField
                    formData={handleInvalidRules(formData.rules)}
                    formContext={formData}
                    onChange={handleRulesChange}
                    errorSchema={errorSchema}
                />
            </div>
            <div style={{ marginBottom: '30px' }}>
                <Conf20FunctionalityControlField
                    formData={formData.functionality_control}
                    formContext={formData}
                    onChange={handleFunctionalityConfigChange}
                />
            </div>
        </div>
    );
};